App.controller('HealthPzuwFormCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', 'dataUser', '$q', '$rootScope', 'healthInsuranceService', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, dataUser, $q, $rootScope, healthInsuranceService, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (dane i oświadczenia)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.health.package';
    $scope.$emit('link', $scope.link);

    $scope.data = {};

    $scope.package = $scope.stateParams.package;
    $scope.data.benefit = $scope.package;

    $scope.previousDeclarationStatus = null;

    if (!$scope.package) {
        $state.go('root.health.package');
    }

    healthInsuranceService.sendInformationDocuments().then(
        function () {
            console.debug("Information documents sent");
        },
        function () {
            $state.go('root.health.package');
        }
    );

    healthInsuranceService.getLastActiveDeclaration('PZUW').then(function (data) {
        if (data.status === 200 && data.data) {
            let lastDeclaration = data.data;
            $scope.previousDeclarationStatus = lastDeclaration.status;
            if (lastDeclaration.status === 'ENDED' || lastDeclaration.status === 'WITHDRAWN') {
                let endedDate = new Date(lastDeclaration.endedDate);
                if (new Date().getMonth() + 1 !== $rootScope.CONFIGURATOR.healthInsurancePzuw.anniversaryChangesMonth) {
                    $scope.showPopUp('', 'Nie można wypełnić deklaracji', `Brak możliwości ponownego przystąpienia przed ${ $rootScope.CONFIGURATOR.healthInsurancePzuw.anniversaryHealthInsuranceDate}`, 'Wróć do strony głównej', 'root.dashboard');
                }
            }
        } else {
            healthInsuranceService.getLastDeclaration('PZUW').then(function (data) {
                if (data.status === 200 && data.data) {
                    let lastDeclaration = data.data;
                    $scope.previousDeclarationStatus = lastDeclaration.status;
                }
            });
        }
    });

    $scope.packageWithRehabilitation = false;
    $scope.pricePackage = 0;
    $scope.namePackage = '';
    if ($scope.package) {
        $scope.packageWithRehabilitation = typeof $scope.package.selectedRehabilitation !== 'undefined' && $scope.package.selectedRehabilitation;
        $scope.pricePackage = $scope.packageWithRehabilitation ?
            $scope.package.summaryPrice + $scope.package.rehabilitationPrice :
            $scope.package.summaryPrice;
        $scope.namePackage = $scope.packageWithRehabilitation ?
            $scope.package.groupName + ' - ' + $scope.package.name + ' + Rehabilitacja ambulatoryjna' :
            $scope.package.groupName + ' - ' + $scope.package.name;
    }

    if ($scope.data.benefit) {
        delete $scope.data.benefit.creationTime;
        if ($scope.data.benefit.benefitGroup) {
            delete $scope.data.benefit.benefitGroup.creationTime;
        }
    }

    $scope.seniorsLength = 0;
    $scope.seniorsLimit = 2;
    if ($scope.package && ($scope.package.variant === 'PARTNER' || $scope.package.variant === 'FAMILY')) {
        $scope.seniorsLimit = 4;
    }

    $scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));

    $scope.data.person = $scope.userData.person;
    delete $scope.data.person.id;
    delete $scope.data.person.creationTime;


    if ($scope.data.person.identifierType === null || $scope.data.person.identifierType === 'undefined') {
        $scope.data.person.citizenshipType = 'POLISH';
        $scope.data.person.identifierType = 'PESEL';
    } else if ($scope.data.person.identifierType === 'PESEL') {
        $scope.data.person.citizenshipType = 'POLISH';
        $scope.data.person.nationality = 'POLISH';
    }

    if ($scope.userData.person.address && $scope.userData.person.address.city) {
        $scope.data.person.address = angular.copy($scope.userData.person.address);
    } else {
        if ($stateParams.lastDeclaration) {
            $scope.data.person.address = angular.copy($stateParams.lastDeclaration.person.address);
        }
    }
    deleteIdentifiedByLongFields($scope.data.person.address);
    function deleteIdentifiedByLongFields(obj) {
        delete $scope.data.person.address.creationTime;
        delete $scope.data.person.address.id;
        delete $scope.data.person.address.createdBy;
        delete $scope.data.person.address.lastModifiedBy;
        delete $scope.data.person.address.lastModifiedTime;
    }
    addStatementsTo($scope.data.person, 'USER');

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    $scope.data.partner = {};
    $scope.data.children = [];
    $scope.data.seniors = [];

    $scope.accept = function () {
        console.log($scope.form);
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    };

    function checkDuplicatedIdentifiers(data) {

        let identifiers = [];
        if (data.person.identifierType && data.person.identifier) {
            identifiers.push(data.person.identifier);
        }

        if (data.partner && data.partner.nationality === 'POLISH' && data.partner.identifier) {
            identifiers.push(data.partner.identifier);
        }

        identifiers = _.concat(identifiers, _.map(_.filter(data.children, {nationality: 'POLISH'}), 'identifier'));
        identifiers = _.concat(identifiers, _.map(_.filter(data.seniors, {nationality: 'POLISH'}), 'identifier'));
        return Object.entries(_.countBy(identifiers))
            .reduce((acc, [key, val]) => {
                return val > 1 ? acc.concat(key) : acc;
            }, [])
            .map(Number);
    }

    $scope.register = function (form) {
        if (!form.$valid) {
            return 0;
        }

        let duplicatedIdentifiers = checkDuplicatedIdentifiers($scope.data);
        if (duplicatedIdentifiers.length > 0) {
            popUpService.showPopUpBigInfo('', '', 'Zgłaszane osoby mają ten sam nr PESEL ' +  _.join(duplicatedIdentifiers, ', ') + ' - sprawdź wypełnione pola');
            return 0;
        }

        if (!areRequiredStatementsChecked($scope.data)) {
            popUpService.showPopUpBigInfo('', 'Zaakceptuj oświadczenia', 'Aby zatwierdzić deklarację zaakceptuj wymagane oświadczenia.');
            return 0;
        }

        let $data = angular.copy($scope.data);
        let partnerLength = ($data.partner && Object.keys($data.partner).length) ? 1 : 0;
        let childrenLength = Object.keys($data.children).length;
        let seniorsLength = Object.keys($data.seniors).length;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                popUpService.showPopUpBigInfo('', 'Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                popUpService.showPopUpBigInfo('', 'Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        // Age validation

        // Employee
        if ($data.person.nationality === 'POLISH') {
            if (!$filter('isOver16FromIdentifier')($data.person.identifier)) {
                popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz przystąpić mając poniżej 16 lat.', '');
                return 0;
            }
        } else {
            if (!$filter('isOver16FromBirthdate')($data.person.birthdate)) {
                popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz przystąpić mając poniżej 16 lat.', '');
                return 0;
            }
        }

        // Partner
        if (partnerLength) {
            if ($data.partner.nationality === 'POLISH') {
                if (!$filter('isOver16FromIdentifier')($data.partner.identifier)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który nie ukończył 16 lat', '');
                    return 0;
                }
                if ($filter('isOver69FromIdentifier')($data.partner.identifier)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który ma powyżej 69 lat', '');
                    return 0;
                }
            } else {
                if (!$filter('isOver16FromBirthdate')($data.partner.birthdate)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który nie ukończył 16 lat', '');
                    return 0;
                }
                if ($filter('isOver69FromBirthdate')($data.partner.birthdate)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który ma powyżej 69 lat.', '');
                    return 0;
                }
            }
        }

        // Children
        if (childrenLength) {
            for (let a = 0; a < childrenLength; a++) {
                if ($data.children[a].member === 'CHILD') {
                    if ($data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver25FromIdentifier')($data.children[a].identifier)) {
                            popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 25 lat.', '');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver25FromBirthdate')($data.children[a].birthdate)) {
                            popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 25 lat.', '');
                            return 0;
                        }
                    }
                }
            }
        }

        // Seniors
        if (seniorsLength) {
            for (let i = 0; i < seniorsLength; i++) {
                if ($data.seniors[i].nationality === 'POLISH') {
                    if (!$filter('isOver16FromIdentifier')($data.seniors[i].identifier)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który nie ukończył 16 lat', '');
                        return 0;
                    }
                    if ($filter('isOver80FromIdentifier')($data.seniors[i].identifier)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który ma powyżej 80 lat.', '');
                        return 0;
                    }
                } else {
                    if (!$filter('isOver16FromBirthdate')($data.seniors[i].birthdate)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który nie ukończył 16 lat', '');
                        return 0;
                    }
                    if ($filter('isOver80FromBirthdate')($data.seniors[i].birthdate)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który ma powyżej 80 lat.', '');
                        return 0;
                    }
                }
            }
        }

        if (Object.keys($data.partner).length) {
            fillMissingDataForInsured($data.partner, $data.person);
        } else {
            delete $data.partner;
        }

        if (childrenLength) {
            for (let a = 0; a < childrenLength; a++) {
                fillMissingDataForInsured($data.children[a], $data.person);
            }
        }

        if (seniorsLength) {
            for (let i = 0; i < seniorsLength; i++) {
                fillMissingDataForInsured($data.seniors[i], $data.person);
            }
        }

        $data.person.citizenshipType = $data.person.nationality;
        $data.person.gender = ($data.person.nationality === 'POLISH') ? $filter('getSexFromIdentifier')($data.person.identifier) : $data.person.gender;
        $data.person.acceptsMarketingElectronicMessages = $data.person.statements[5].checked;
        $data.proposedDate = $scope.stateParams.proposedDate;
        $data.branch = $scope.userData.branch.name;

        if ($scope.packageWithRehabilitation) {
            $data.rehabilitation = true;
        }

        console.debug($data);

        healthInsuranceService.add($data, false).then(function (data) {
            if (data.status === 200) {
                dataUser.update();
                $state.go('root.health.summary', {
                    declaration: data.data,
                    summaryPrice: $scope.pricePackage,
                    previousDeclarationStatus: $scope.previousDeclarationStatus,
                });
            } else {
                popUpService.showPopUpWithError(data.data, {
                    ev: '',
                    head: 'Zgłoszenie nieudane',
                    content: 'Niestety nie udało się zgłosić deklaracji, skontaktuj się z administratorem.',
                    text: '',
                    target: ''
                });
            }
        });
    };

    function fillMissingDataForInsured(insured, person) {
        insured.identifierType = (insured.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
        insured.identifier = (insured.nationality !== 'POLISH') ? insured.id : insured.identifier;
        insured.birthdate = (insured.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')(insured.birthdate) : $filter('getDateFromIdentifier')(insured.identifier);
        insured.citizenshipType = insured.nationality;
        insured.gender = (insured.nationality === 'POLISH') ? $filter('getSexFromIdentifier')(insured.identifier) : insured.gender;
        insured.acceptsMarketingElectronicMessages = insured.statements[5].checked;
        if (insured.sameAddress) {
            insured.address = angular.copy(person.address);
        }

        delete insured.nationality;
        delete insured.id;
        delete insured.sameAddress;
    }

    function areRequiredStatementsChecked(data) {
        let isValid = true;
        isValid = isValid && areRequiredStatementsForPersonChecked(data.person);
        if (Object.keys(data.partner).length) {
            isValid = isValid && areRequiredStatementsForPersonChecked(data.partner);
        }
        for (let i = 0; i < data.children.length; i++) {
            isValid = isValid && areRequiredStatementsForPersonChecked(data.children[i]);
        }
        return isValid;
    }

    function areRequiredStatementsForPersonChecked(person) {
        let isValid = true;
        for (let i = 0; i < person.statements.length; i++) {
            if (person.statements[i].required) {
                isValid = isValid && person.statements[i].checked;
            }
        }
        return isValid;
    }

    function addStatementsTo(person, personType) {
        if (!person) {
            return;
        }
        person.statements = [
            {
                text: personType === 'USER' ? '1. Przed objęciem mnie ochroną ubezpieczeniową i wyrażeniem zgody na finansowanie kosztu składki ubezpieczeniowej (jeżeli składka jest w całości lub części finansowana z moich środków) doręczono mi warunki umowy, w tym Ogólne Warunki Grupowego Ubezpieczenia TUW PZUW Opieka Medyczna (OM) ustalone Uchwałą Zarządu Towarzystwa Ubezpieczeń Wzajemnych Polskiego Zakładu Ubezpieczeń Wzajemnych nr UZ/121/2021 z dnia 31 sierpnia 2021 r., ze zmianami wprowadzonymi uchwałą Zarządu Towarzystwa Ubezpieczeń Wzajemnych Polskiego Zakładu Ubezpieczeń Wzajemnych nr UZ/122/2022 z dnia 9 sierpnia 2022 r., zawartej przez ubezpieczającego „PKP Intercity” S.A. z Towarzystwem Ubezpieczeń Wzajemnych Polskim Zakładem Ubezpieczeń Wzajemnych.' :
                    '1. Przed objęciem mnie ochroną ubezpieczeniową doręczono mi warunki umowy, w tym Ogólne Warunki Grupowego Ubezpieczenia TUW PZUW Opieka Medyczna (OM) ustalone Uchwałą Zarządu Towarzystwa Ubezpieczeń Wzajemnych Polskiego Zakładu Ubezpieczeń Wzajemnych nr UZ/121/2021 z dnia 31 sierpnia 2021 r., ze zmianami wprowadzonymi uchwałą Zarządu Towarzystwa Ubezpieczeń Wzajemnych Polskiego Zakładu Ubezpieczeń Wzajemnych nr UZ/122/2022 z dnia 9 sierpnia 2022 r., zawartej przez ubezpieczającego „PKP Intercity” S.A. z Towarzystwem Ubezpieczeń Wzajemnych Polskim Zakładem Ubezpieczeń Wzajemnych.',
                checked: false,
                required: true,
                checkbox: true
            },
            {
                text: '2. Stałym miejscem mojego zamieszkania jest Rzeczpospolita Polska.',
                checked: false,
                required: true,
                checkbox: true
            },
            {
                text: '3. Nie przebywam, w szpitalu, hospicjum, placówce dla przewlekle chorych i na świadczeniu rehabilitacyjnym. Nie zostałem uznana/-y za osobę niezdolną do pracy lub niezdolną do służby orzeczeniem właściwego organu według przepisów o ubezpieczeniu społecznym lub zaopatrzeniu społecznym.',
                checked: false,
                required: true,
                checkbox: true
            },
            {
                text: '4. Wyrażam zgodę na udzielanie mi świadczeń zdrowotnych w ramach umowy ubezpieczenia zawartej z Towarzystwem Ubezpieczeń Wzajemnych Polskim Zakładem Ubezpieczeń Wzajemnych, w tym na uzyskanie dostępu do mojej dokumentacji medycznej przez świadczeniodawcę PZU Zdrowie.',
                checked: false,
                required: true,
                checkbox: true
            },
            {
                text: '5. Wyrażam zgodę na uzyskiwanie przez Towarzystwo Ubezpieczeń Wzajemnych Polski Zakład Ubezpieczeń Wzajemnych od podmiotów wykonujących działalność leczniczą danych dotyczących stanu mojego zdrowia związanych z ustaleniem prawa do świadczenia z umowy ubezpieczenia i wysokością tego świadczenia, obejmujących informacje o: 1) przyczynach hospitalizacji, wykonanych w jej trakcie badaniach diagnostycznych i ich wynikach, innych udzielonych świadczeniach zdrowotnych, wynikach leczenia; 2) przyczynach leczenia ambulatoryjnego, wykonanych w jego trakcie badaniach diagnostycznych i ich wynikach, innych udzielonych świadczeniach zdrowotnych oraz wynikach leczenia; 3) wynikach przeprowadzonych konsultacji; z wyłączeniem wyników badań genetycznych.',
                checked: false,
                required: true,
                checkbox: true
            },
            {
                text: '6. Wyrażam zgodę na wysłanie maila powitalnego wraz z informacją o możliwości założenia konta w portalu moje.pzu.pl na wskazany wyżej numer telefonu i adres e-mail.',
                checked: false,
                required: false,
                checkbox: true
            },
            {
                text: 'Każdą z powyższych zgód można wycofać w każdym czasie, kontaktując się z TUW Polskim Zakładem Ubezpieczeń Wzajemnych na adres e-mail iod@tuwpzuw.pl. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem.',
                checked: false,
                required: false,
                checkbox: false
            },
            {
                text: '7. Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie Informacja Administratora danych osobowych dla Ubezpieczonego/Współubezpieczonego w ramach umowy ubezpieczenia.',
                checked: false,
                required: true,
                checkbox: true
            }
        ];
    }

    $scope.addInsured = function (type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                nationality: 'POLISH',
                address: angular.copy($scope.data.person.address),
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
            addStatementsTo($scope.data.partner, type);
        }

        if (type === 'CHILD') {

            let child = {
                nationality: 'POLISH',
                member: 'CHILD',
                address: angular.copy($scope.data.person.address),
                sameAddress: true
            };
            addStatementsTo(child, type);
            $scope.data.children.push(child);

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= 7) {
                    $scope.children_block = true;
                }
            }
        }

        if (type === 'SENIOR') {

            let senior = {
                nationality: 'POLISH',
                member: 'SENIOR',
                address: angular.copy($scope.data.person.address),
                sameAddress: true
            };
            addStatementsTo(senior, type);
            $scope.data.seniors.push(senior);

            $scope.pricePackage += $scope.package.seniorPrice;

            $scope.seniorsLength = Object.keys($scope.data.seniors).length;
        }
    };


    $scope.deleteInsured = function (type, index) {
        if (type === 'PARTNER') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else if (type === 'CHILD') {
            $scope.data.children.splice(index, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        } else if (type === 'SENIOR') {
            $scope.data.seniors.splice(index, 1);
            $scope.seniorsLength = Object.keys($scope.data.seniors).length;
            $scope.pricePackage -= $scope.package.seniorPrice;
        }
    };

    $scope.$watch('data.person.address', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (let a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                    }
                }
            }
        }
    }, true);

    $scope.$watch('data.partner.sameAddress', function (newValue , oldValue) {
        if (oldValue !== newValue && newValue !== undefined) {
            if ($scope.data.partner.sameAddress) {
                $scope.data.partner.address = angular.copy($scope.data.person.address);
                $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
            } else {
                $scope.data.partner.address = {};
                $scope.data.partner.selectedItemLocalization = null;
            }
        }
    });
    $scope.$watch('data.children[0].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(0);
        }
    });
    $scope.$watch('data.children[1].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(1);
        }
    });
    $scope.$watch('data.children[2].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(2);
        }
    });
    $scope.$watch('data.children[3].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(3);
        }
    });
    $scope.$watch('data.children[4].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(4);
        }
    });
    $scope.$watch('data.children[5].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(5);
        }
    });
    $scope.$watch('data.children[6].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(6);
        }
    });
    $scope.$watch('data.children[7].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(7);
        }
    });
    function onChildrenSameAddressUpdate(i) {
        if ($scope.data.children[i].sameAddress) {
            $scope.data.children[i].address = angular.copy($scope.data.person.address);
            $scope.data.children[i].selectedItemLocalization = $scope.selectedItemLocalization;
        } else {
            $scope.data.children[i].address = {};
            $scope.data.children[i].selectedItemLocalization = null;
        }
    }
    $scope.$watch('data.seniors[0].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onSeniorSameAddressUpdate(0);
        }
    });
    $scope.$watch('data.seniors[1].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onSeniorSameAddressUpdate(1);
        }
    });
    $scope.$watch('data.seniors[2].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onSeniorSameAddressUpdate(2);
        }
    });
    $scope.$watch('data.seniors[3].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onSeniorSameAddressUpdate(3);
        }
    });
    function onSeniorSameAddressUpdate(i) {
        if ($scope.data.seniors[i].sameAddress) {
            $scope.data.seniors[i].address = angular.copy($scope.data.person.address);
            $scope.data.seniors[i].selectedItemLocalization = $scope.selectedItemLocalization;
        } else {
            $scope.data.seniors[i].address = {};
            $scope.data.seniors[i].selectedItemLocalization = null;
        }
    }
}]);
